/**
 * URLs de imágenes de una noticia (imagenes_url JSON + imagen_url legado).
 */
export function parseNoticiaImagenes(noticia) {
  if (!noticia) return [];
  const out = [];
  if (noticia.imagenes_url) {
    try {
      const arr = JSON.parse(noticia.imagenes_url);
      if (Array.isArray(arr)) {
        arr.forEach((u) => {
          if (u && typeof u === 'string') out.push(u.trim());
        });
      }
    } catch (e) {
      /* ignorar JSON inválido */
    }
  }
  if (out.length === 0 && noticia.imagen_url) {
    out.push(String(noticia.imagen_url).trim());
  }
  return [...new Set(out.filter(Boolean))];
}

/** ID de video YouTube (11 caracteres) a partir de URL pública o embed. */
export function getYoutubeVideoId(url) {
  const embed = getYoutubeEmbedUrl(url);
  if (!embed) return null;
  const match = embed.match(/\/embed\/([a-zA-Z0-9_-]{11})/);
  return match ? match[1] : null;
}

/** Miniatura de YouTube para vista previa con botón play. */
export function getYoutubeThumbnailUrl(url, quality = 'hqdefault') {
  const id = getYoutubeVideoId(url);
  return id ? `https://img.youtube.com/vi/${id}/${quality}.jpg` : null;
}

/** Tarjeta con carrusel o video: la media no debe ir dentro de un Link que envuelva toda la tarjeta. */
export function noticiaTieneMediaInteractiva(noticia) {
  const urls = parseNoticiaImagenes(noticia);
  const slides = buildNoticiaCardSlides(noticia);
  if (slides.length > 1) return true;
  if (slides.length === 1 && slides[0].type === 'video') return true;
  if (urls.length > 1) return true;
  return false;
}

/** Diapositivas para tarjetas: video (si hay) + imágenes. */
export function buildNoticiaCardSlides(noticia) {
  const urls = parseNoticiaImagenes(noticia);
  const embedUrl = getYoutubeEmbedUrl(noticia?.video_url);
  const slides = [];
  if (embedUrl) {
    slides.push({ type: 'video', embedUrl, videoUrl: noticia.video_url });
  }
  urls.forEach((src) => slides.push({ type: 'image', src }));
  return slides;
}

/** URL de embed de YouTube a partir del enlace público. */
export function getYoutubeEmbedUrl(url) {
  if (!url || typeof url !== 'string') return null;
  try {
    const parsedUrl = new URL(url.trim());
    const hostname = parsedUrl.hostname.replace(/^www\./, '');
    let videoId = null;

    if (hostname === 'youtu.be') {
      videoId = parsedUrl.pathname.split('/').filter(Boolean)[0] || null;
    } else if (hostname === 'youtube.com' || hostname === 'm.youtube.com') {
      if (parsedUrl.pathname === '/watch') {
        videoId = parsedUrl.searchParams.get('v');
      } else if (parsedUrl.pathname.startsWith('/shorts/')) {
        videoId = parsedUrl.pathname.split('/')[2] || null;
      } else if (parsedUrl.pathname.startsWith('/embed/')) {
        videoId = parsedUrl.pathname.split('/')[2] || null;
      }
    }

    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  } catch (error) {
    return null;
  }
}
